import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20peach%20and%20coral%20tones%2C%20modern%20geometric%20shapes%20floating%2C%20dreamy%20atmosphere%2C%20minimalist%20art%20style%2C%20cinematic%20composition&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="紅桃視頻高清短視頻平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24 text-center">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-6 leading-tight">
          发现精彩世界
          <br />
          <span className="text-primary-400">从这里开始</span>
        </h1>
        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          紅桃視頻为您精选海量高清短视频，覆盖娱乐、美食、旅行、音乐等数十个分类。
          <br className="hidden md:block" />
          流畅播放，高清画质，随时随地畅享优质内容。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#download"
            className="whitespace-nowrap px-8 py-3.5 text-base font-medium rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200"
          >
            <i className="ri-download-2-line mr-2"></i>
            免费下载App
          </a>
          <Link
            to="/category/entertainment"
            className="whitespace-nowrap px-8 py-3.5 text-base font-medium rounded-full border-2 border-background-50/40 text-background-50 hover:bg-background-50/15 transition-all duration-200"
          >
            <i className="ri-compass-3-line mr-2"></i>
            浏览内容
          </Link>
        </div>

        <div className="mt-12 flex items-center justify-center gap-8">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">5000万+</p>
            <p className="text-sm text-background-50/60 mt-1">注册用户</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">100万+</p>
            <p className="text-sm text-background-50/60 mt-1">日更视频</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">12个</p>
            <p className="text-sm text-background-50/60 mt-1">内容分类</p>
          </div>
        </div>
      </div>
    </section>
  );
}